// extracted by mini-css-extract-plugin
export default {"cart":"Drawer_cart__ss8ma","cartBody":"Drawer_cartBody__DImCu","itemWrapper":"Drawer_itemWrapper__h6FdU"};